<template>
  <nav class="site-nav navbar navbar-expand-md bg-primary navbar-dark">
    <router-link class="navbar-brand title" to="/">
      <img src="profile.jpg" />
      Kohaku's Journey
    </router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbar-content"
      aria-controls="navbar-content"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbar-content">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Projects
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <router-link class="dropdown-item" to="calculator"
              >Calculator</router-link
            >
            <a class="dropdown-item" href="https://kohaku.me/lcc-javascript-vue"
              >LCC Javascript in Vuejs</a
            >
          </div>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="Resume">
            <font-awesome-icon :icon="['fas', 'code-branch']" /><span
              >Resume</span
            >
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="About">
            <font-awesome-icon :icon="['fas', 'user-circle']" /><span
              >About Me</span
            >
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
img {
  max-width: 4rem;
  max-height: 4rem;
  border: 0.15rem solid hsla(245, 70%, 50%, 0.2);
  background-color: gray;
  border-radius: 50%;
  margin-right: 1em;
}

.title {
  font-family: "Aclonica", sans-serif;
  font-size: 1.25em;
}

span {
  font-weight: 600;
  padding: 0 0.15em 0 0.15em;
}
</style>
